<template>

    <Head title="Calendario semanal" />


    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
        <p class="title"><strong>Pesquisa</strong></p>
        <form class="mt-1 w-full" @submit.prevent="reloadTable">
            <div class="flex flex-wrap mb-4 px-4">
                <multi-select-input
                    v-model="filters.WeekList.market_network"
                    :multiple="true"
                    :options="options.marketNetworkSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Rede"
                />

                <multi-select-input
                    v-model="filters.WeekList.market"
                    :multiple="true"
                    :options="options.marketSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Mercado"
                />

                <multi-select-input
                    v-model="filters.WeekList.provider"
                    :multiple="true"
                    :options="options.providerSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Fornecedor"
                />

                <multi-select-input
                    v-model="filters.WeekList.brand"
                    :multiple="true"
                    :options="options.brandSearch"
                    class="lg:pr-6 w-full lg:w-1/4"
                    label="Marca"
                />
            </div>
            <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
                <button
                    class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                    @click="handleSearch">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                </button>

                <button 
                    class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100" 
                    @click="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                </button>
            </div>
        </form>
    </div>

    <div 
        class="w-full" 
        v-for="index in 7"
        :key="index">
            <h1 class="text-lg text-gray-500 my-9 lg:text-2xl mb-3 capitalize">
                {{ formatDate(index - 1) }}
            </h1>

            <div class="w-full bg-white px-4 pt-10 pb-4 shadow-[0px_1px_4px_#15223214] rounded-md font-poppins text-sm">
                <ul 
                    class="mb-4 lg:hidden w-full" 
                    v-if="getWeekData(index).length">
                        <template 
                            v-for="(week, i) in getWeekData(index)" 
                            :key="i">

                            <li class="text-base font-poppins font-bold uppercase mt-6">promotor</li>
                            <li class="text-base font-poppins">{{ week.sales_promoter_name }}</li>
                            
                            <li class="text-base font-poppins font-bold uppercase mt-6">mercado</li>
                            <li class="text-base font-poppins">{{ week.market_network_name }}</li>
                            
                            <li class="text-base font-poppins font-bold uppercase mt-6">fornecedor</li>
                            <li class="text-base font-poppins">{{ week.provider_name }}</li>
                            
                            <li class="text-base font-poppins font-bold uppercase mt-6">marca</li>
                            <li class="text-base font-poppins">{{ week.brand_name }}</li>
                            
                            <li class="text-base font-poppins font-bold uppercase mt-6">produtos</li>
                            <li class="text-base font-poppins">
                                <p class="break-words leading-6 text-left">{{ formatProducts(week.products) }}</p>
                            </li>
                            
                            <li class="text-base font-poppins font-bold uppercase mt-6">status</li>
                            <li class="text-base font-poppins">
                                <font-awesome-icon 
                                    :icon="'fa-regular ' + getIcon(week.days_of_the_week_visit, week.days_of_the_week_visit_required, index, week.status)"
                                    :class="getClass(week.days_of_the_week_visit, week.days_of_the_week_visit_required, index, week.status)" />
                            </li>
                            
                            <li class="text-base font-poppins font-bold uppercase mt-6">relatório</li>
                            <li class="text-base font-poppins">
                                <Link
                                    as="button"
                                    :href="`/activity_management/detail/${week.report_id}`"
                                    class="w-full my-1 px-3 py-2 text-xs font-roboto font-medium btn-primary uppercase">
                                        Ver Relatório

                                        <font-awesome-icon icon="fa-solid fa-angle-right" class="ml-2" />
                                </Link>
                            </li>
                        </template>
                </ul>

                <div v-else>
                    <p class="text-center font-poppins text-gray-500 text-base">Nenhuma atividade</p>
                </div>
                
                <table class="w-full hidden lg:table">
                    <thead class="w-full">
                        <tr class="bg-[#f5f6fa] text-xs">
                            <th class="py-4">promotor</th>
                            <th class="py-4">mercado</th>
                            <th class="py-4">fornecedor</th>
                            <th class="py-4">marca</th>
                            <th class="py-4">produtos</th>
                            <th class="py-4">status</th>
                            <th class="py-4">relatório</th>
                        </tr>
                    </thead>

                    <tbody>
                        <template v-if="getWeekData(index).length">
                            <tr 
                                v-for="(week, i) in getWeekData(index)" 
                                :key="i">
                                    <td class="pt-5 text-center align-top">{{ week.sales_promoter_name }}</td>
                                    <td class="pt-5 text-center align-top">{{ week.market_network_name }}</td>
                                    <td class="pt-5 text-center align-top">{{ week.provider_name }}</td>
                                    <td class="pt-5 text-center align-top">{{ week.brand_name }}</td>
                                    <td class="pt-5 text-center align-top max-w-[180px]">
                                        <p class="break-words leading-6 text-left">{{ formatProducts(week.products) }}</p>
                                    </td>

                                    <td class="pt-5 text-center align-top text-lg">
                                        <font-awesome-icon 
                                            :icon="'fa-regular ' + getIcon(week.days_of_the_week_visit, week.days_of_the_week_visit_required, index, week.status)"
                                            :class="getClass(week.days_of_the_week_visit, week.days_of_the_week_visit_required, index, week.status)" />
                                    </td>

                                    <td class="pt-5 align-top">
                                        <Link
                                            as="button"
                                            :href="`/activity_management/detail/${week.report_id}`"
                                            class="w-full my-1 px-3 py-2 text-xs font-roboto font-medium btn-primary uppercase">
                                                Ver Relatório

                                                <font-awesome-icon icon="fa-solid fa-angle-right" class="ml-2" />
                                        </Link>
                                    </td>
                            </tr>
                        </template>

                        <tr v-else>
                            <td colspan="7">
                                <p class="text-center font-poppins mt-2 text-gray-500 text-base">Nenhuma atividade</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>

</template>

<script>

import axios from 'axios'

import { Head, Link } from '@inertiajs/inertia-vue3'

import MultiSelectInput from '@/Shared/MultiSelectInput'
import Layout from '@/Shared/Layout'
import DataTable from '@/Shared/DataTable'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'


export default {
    components: {
        Head,
        DataTable,
        Link,
        MultiSelectInput,
    },

    layout: Layout,

    mixins: [
        getFiltersMixin,
    ],

    data() {
        return {
            loadTable: true,
            
            sales_promoter: null,
            date: null,
            
            weeks: null,

            options: {
                marketNetworkOptions: [],
                marketOptions: [],
                providerOptions: [],
                brandsOpetions: [],
            },
        }
    },


    created() {

        const url = new URL(window.location.href)

        const splitedDate = url.searchParams.get('date').split('-')
        
        this.date = new Date(splitedDate[0], Number(splitedDate[1]) - 1, splitedDate[2])
        this.sales_promoter = url.searchParams.get('id')

        this.findData()
        this.startWeek()
    },


    watch: {
        'filters.WeekList': {
            handler() {
                this.getFiltersFromAPI()
            },
            deep: true,
        }
    },


    methods: {
        startWeek() {
            this.date.setDate(this.date.getDate() - this.date.getDay())
        },

        formatDate(index) {
            const temp = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + index)

            return temp.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })
        },


        getWeekData(index) {
            const temp = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + index)

            const formatDate = this.$filters.formatDate(temp, 'yyyy-MM-dd')

            if (this.weeks && Object.keys(this.weeks).includes(formatDate))
                return this.weeks[formatDate]

            return []
        },


        formatProducts(products) {
            return products.map(product => product.name).splice(0, 3).join(', ')
        },


        clearSearch() {
            this.clearFilters()
            this.findData()
        },

        
        getIcon(days_of_the_week_visit, days_of_the_week_visit_required, index, status) {
            const temp = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + index)

            const daysVisit = JSON.parse(days_of_the_week_visit)
            const daysVisitRequired = JSON.parse(days_of_the_week_visit_required)

            if (daysVisitRequired.includes(temp.getDay()) && status != 3)
                return 'fa-xmark-circle'

            else if (daysVisit.includes(temp.getDay()))
                return 'fa-circle-check'

            return 'fa-circle'
        },


        getClass(days_of_the_week_visit, days_of_the_week_visit_required, index, status) {
            const temp = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + index)

            const daysVisit = JSON.parse(days_of_the_week_visit)
            const daysVisitRequired = JSON.parse(days_of_the_week_visit_required)

            if (daysVisitRequired.includes(temp.getDay()) && status != 3)
                return 'text-red-600'

            else if (daysVisit.includes(temp.getDay()))
                return 'text-green-600'

            return 'text-gray-400'
        },


        handleSearch() {
            this.findData()
        },

        getQueryFilters() {
            const filters = {
                date: this.$filters.formatDate(this.date, 'yyyy-MM-dd'),
                sales_promoter: this.sales_promoter,
                ...this.getFilters()
            }

            return Object.entries( filters ).map( ( [key, val] ) => `search[${key}]=${val}` ).join( '&' )
        },



        async findData() {
            const query = this.getQueryFilters()

            try {
                const response = await axios.get('/week_details/list?' + query )
                this.weeks = response.data
            }

            catch {
                this.$toast.error('Erro ao buscar dados, tente novamente.')
            }
        },
    },


    setup() {
        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent( 'WeekList', {
            market_network: [],
            market: [],
            provider: [],
            brand: [],
        } )

        const clearFilters = () => clearFiltersComponent( 'WeekList', {

            market_network: [],
            market: [],
            provider: [],
            brand: [],
        } )

        const getFilters = () => getFiltersComponent( 'WeekList' )

        return { 
            getFilters,
            clearFilters, 
            filters: filtersStore.filters
        }
    },
}


</script>
